/* eslint-disable no-empty */
import { h, Component, Fragment } from 'preact';
import { trackWindowScroll } from '../../atoms/LazyLoadedImage';
import { route } from 'preact-router';
import debounce from 'lodash.debounce';
import CommonHeader from '../../organisms/CommonHeader';
import SearchResults from '../../molecules/SearchResults';
import CompanyAdTile from '../../molecules/AdTile/CompanyAdTile';
import groupCatalogueHOC from '../HOC/groupCatalogueHOC';
import './index.less';

import { driftCompanyId } from '../../../config';
import {
  shouldRemoveCompanyContactDetails,
  shouldRenderCustomPageCatalogueSettingsSection
} from '../../lib/Experiments';
import { createOrGetVisitor } from '../../lib/GroupAnalytics';
import { getCompanyId, getCompanyName } from '../../lib/Company';
import {
  areMoreCataloguesAvailable,
  getViewAllCustomPageCatalogueAmalgam,
  getVisitorId as amalgamGetVisitorId,
  isViewAllCatalogueAmalgamFetched,
  setMoreCataloguesAvailable
} from '../../lib/GroupAmalgam';
import ChatButton from '../../organisms/ChatButton';
import OrderBar from '../../organisms/OrderBar';
import PrimaryLoader from '../../organisms/PrimaryLoader';
import {
  getRouteParams,
  importGroupBundle,
  importSingleBundle,
  isLazyComponentFetched,
  setLastVisitedGroupCatalogueLink,
  setLazyComponent
} from '../../lib/Route';
import {
  CUSTOM_PAGE_SHOW_CONTENT_DESKTOP,
  CUSTOM_PAGE_SHOW_CONTENT_MOBILE,
  getSearchTermFromUrl,
  HOME_LAYOUT_TYPE,
  setSearchTermGlobally,
  shouldProcessClick,
  isNavigatingToCurrentLink,
  CHUNK_VIEW,
  getItemsPerRow,
  SECTION_TYPES,
  CUSTOM_PAGE_CATALOGUE_TILES_PER_ROW_DEFAULT,
  isResellerBundleView,
  HTML_TYPES
} from '../../lib/Utils';
import {
  getTileHeight,
  setTileHeight,
  setGalleryProductId,
  CUSTOM_PAGE_VIEW_VERTICAL_MARGIN
} from '../../lib/PositionCache';
import CatalogueList from '../../organisms/CatalogueList';
import CustomPageCatalogueList from '../../organisms/CustomPageCatalogueList';
import {
  getAmalgam,
  getCatalogueTheme,
  isAmalgamFetched,
  getCustomPageAmalgamPaginated,
  setCustomPageScrollPosition,
  getCustomPageScrollPosition,
  getSiteTitle,
  getProductGridTileComponent
} from '../../lib/Amalgam';
import ProductRow from '../../organisms/ProductRow';
import WhatsAppBrand from '../../molecules/Icon/WhatsAppBrand';
import I18n from '../../lib/I18n';
import { VIEW_TYPES } from '../../molecules/OutOfStockBadge';
import CustomPageBanner from '../CustomPageBanner';
import CustomHtmlRenderer from '../CustomHtmlRenderer';
import SearchBar from '../../molecules/SearchBar';
import CustomPageViewAllArrowRight from '../../molecules/Icon/CustomPageViewAllArrowRight';
import CustomPageCategoriesList from '../../molecules/CustomPageCategoriesList';
import ProductGridTileCustomComponent from '../../organisms/ProductGridTile/CustomComponent';
import {
  getCustomPage,
  setCustomPageCatalogues,
  setCustomPageHiddenCatalogueActionButtonThemes,
  setCustomPageGroupShowcases,
  setCustomPageProducts,
  setCustomPageSections,
  setCustomPageSingleShowcases,
  mergeProductsIntoDefaultVariants
} from '../../lib/CustomPageAmalgam';
import { setProductSectionHomePage } from '../../lib/GroupCatalogueAmalgam';
import RenewalReminderCard from '../../organisms/RenewalReminderCard';
import NoSection from './NoSection';
import CustomVirtualList from '../../molecules/CustomVirtualList';
import { setNativeNavigationBarColor } from '../../../../../nativeConnectors/platform';
import EventBus from '../../lib/EventBus';

const PRODUCT_SECTION_ROWS = {};
const PRODUCT_VIRTUAL_LISTS = {};

class CustomPage extends Component {
  constructor (props) {
    super(props);
    const customPage = getCustomPage();
    const {
      products = [],
      catalogues = [],
      hiddenCatalogueActionButtonThemes = [],
      groupShowcases = [],
      singleShowcases = [],
      sections = []
    } = customPage;
    this.state = {
      fetchingAmalgam: false,
      showLoader: true,
      showAdTile: !areMoreCataloguesAvailable(),
      visitorInitialized: false,
      searchTerm: getSearchTermFromUrl(),
      resetSearchState: true,
      searchClickedFromNavBar: false,
      sections,
      viewAllSectionId: null,
      products,
      catalogues,
      hiddenCatalogueActionButtonThemes,
      groupShowcases,
      singleShowcases,
      customPageSectionsCount: 0,
      fetchingSections: false,
      orderBarVisible: false,
      itemsPerRow: getItemsPerRow(),
      productVirtualListRefs: {},
      productSectionTileWidth: this.getProductSectionTileWidth()
    };
    this.isMounted = false;
  }

  componentDidMount () {
    setGalleryProductId(null);
    setProductSectionHomePage(null);
    const customPageScrollPosition = getCustomPageScrollPosition();
    // Note: don't remove this set-timeout, else page scroll won't work when there's pagination
    setTimeout(() => {
      window.scrollTo(0, customPageScrollPosition);
    }, 0);

    document.addEventListener('scroll', this.scrollPositionCacheHandler);
    window.addEventListener('resize', this.handleOnResize);

    const {
      title: customPageTitle,
      isFrontPage,
      sections = [],
      customPageSectionsCount
    } = getCustomPage();
    const { backgroundColor = '#ffffff' } = getCatalogueTheme().homeGrid || {};
    document.querySelector('.app').style.backgroundColor = backgroundColor;
    document.body.style.backgroundColor = backgroundColor;
    const siteTitle = getSiteTitle();
    if (siteTitle) {
      document.title = siteTitle;
    } else {
      document.title = (isFrontPage ? getCompanyName() : customPageTitle) || '';
    }
    this.isMounted = true;
    this.initializeVisitor();

    setLastVisitedGroupCatalogueLink(getCompanyId());

    this.setState({
      sections,
      customPageSectionsCount: customPageSectionsCount || 0
    });
    if (customPageSectionsCount > sections.length) {
      document.addEventListener('scroll', this.onScroll);
    }
    this.handleFooterColor();
  }

  componentWillReceiveProps (nextProps) {
    if (!nextProps.searchTerm) {
      setSearchTermGlobally('');
    }

    if (this.props.searchTerm !== nextProps.searchTerm) {
      setSearchTermGlobally('');
      setGalleryProductId(null);
      window.scrollTo(0, 0);
    }

    if (!getSearchTermFromUrl()) {
      this.resetSearchResultState();
    }
  }

  componentDidUpdate (prevProps, previousState) {
    if (
      prevProps.matches.customPageSlug !== this.props.matches.customPageSlug &&
      (!!prevProps.matches.customPageSlug || !!this.props.matches.customPageSlug) &&
      this.props.groupAmalgamFetched
    ) {
      // NOTE: this check is needed to handle the state white custom page to custom page route switch
      // For example when user clicks on a banner section image that is linked to another custom page
      window.scrollTo(0, 0);
      const customPage = getCustomPage();
      const {
        title: customPageTitle,
        isFrontPage,
        products = [],
        catalogues = [],
        hiddenCatalogueActionButtonThemes = [],
        groupShowcases = [],
        singleShowcases = [],
        sections = [],
        customPageSectionsCount
      } = customPage;
      this.setState({
        sections,
        viewAllSectionId: null,
        products,
        catalogues,
        hiddenCatalogueActionButtonThemes,
        groupShowcases,
        singleShowcases,
        customPageSectionsCount,
        fetchingSections: false
      });
      document.title = isFrontPage ? getCompanyName() : customPageTitle;
    }
    const { showAdTile } = this.state;
    const { showAdTile: previousShowAdTile } = previousState;
    if (showAdTile !== previousShowAdTile) {
      this.handleFooterColor();
    }
  }

  componentWillUnmount () {
    this.isMounted = false;
    document.removeEventListener('scroll', this.scrollPositionCacheHandler);
    document.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.handleOnResize);
  }

  handleFooterColor = () => {
    const { orderBarVisible } = this.state;
    if (orderBarVisible) {
      // Color will be handled by Order Bar Component on becoming visible
      return;
    }

    const { homeGrid } = getCatalogueTheme() || {};

    const { backgroundColor } = homeGrid || {};
    setNativeNavigationBarColor(backgroundColor);
  };

  getProductSectionTileWidth = () => {
    const maxContainerWidth = 1350 + 20;
    const tilesPerRowCount = window.innerWidth >= 1025 ? 5 : window.innerWidth >= 668 ? 3 : 2;
    return window.innerWidth >= maxContainerWidth
      ? (maxContainerWidth - 20) / tilesPerRowCount
      : (window.innerWidth - 20) / tilesPerRowCount;
  };

  handleOnResize = debounce(() => {
    this.setState({
      productSectionTileWidth: this.getProductSectionTileWidth(),
      itemsPerRow: getItemsPerRow()
    });
  }, 500);

  onScroll = debounce(() => {
    const rootElement = document.querySelector('#root');
    if (
      rootElement &&
      window.innerHeight + window.scrollY + 330 >= rootElement.offsetHeight &&
      !this.state.fetchingSections
    ) {
      const { customPageSlug } = getRouteParams();
      const customPage = getCustomPage();
      const lastSection = this.state.sections[this.state.sections.length - 1];
      this.setState({ fetchingSections: true });
      getCustomPageAmalgamPaginated({
        companyId: getCompanyId(),
        customPageId: customPage.id,
        customPageSlug,
        afterPosition: lastSection.order || this.state.sections.length
      })
        .then((response) => {
          this.setState({ fetchingSections: false });
          const scrollY = window.scrollY;
          const sections = [...this.state.sections, ...response.customPage.sections];
          const products = this.removeDuplicateObjects(
            [...this.state.products, ...response.customPage.products],
            'id'
          );
          const catalogues = this.removeDuplicateObjects(
            [...this.state.catalogues, ...response.customPage.catalogues],
            'id'
          );
          const hiddenCatalogueActionButtonThemes = this.removeDuplicateObjects(
            [
              ...this.state.hiddenCatalogueActionButtonThemes,
              ...response.customPage.hiddenCatalogueActionButtonThemes
            ],
            'catalogueId'
          );
          const singleShowcases = this.removeDuplicateObjects(
            [...this.state.singleShowcases, ...response.customPage.singleShowcases],
            'id'
          );
          const groupShowcases = this.removeDuplicateObjects(
            [...this.state.groupShowcases, ...response.customPage.groupShowcases],
            'id'
          );
          setCustomPageCatalogues(catalogues);
          setCustomPageHiddenCatalogueActionButtonThemes(hiddenCatalogueActionButtonThemes);
          setCustomPageProducts(products);
          mergeProductsIntoDefaultVariants({ productIds: products.map((product) => product.id) });
          setCustomPageSingleShowcases(singleShowcases);
          setCustomPageGroupShowcases(groupShowcases);
          setCustomPageSections(sections);

          this.setState(
            {
              sections,
              products,
              catalogues,
              hiddenCatalogueActionButtonThemes,
              singleShowcases,
              groupShowcases
            },
            () => {
              window.scrollTo(0, scrollY);
            }
          );
          if (this.state.customPageSectionsCount === sections.length) {
            document.removeEventListener('scroll', this.onScroll);
          }
        })
        .catch(() => {
          this.setState({ fetchingSections: false });
        });
    }
  }, 200);

  removeDuplicateObjects = (array, keyProp = 'id') => {
    const uniqIds = {};

    return array.filter((obj) => !uniqIds[obj[keyProp]] && (uniqIds[obj[keyProp]] = true));
  };

  initializeVisitor = () => {
    const amalgamVisitorId = amalgamGetVisitorId();

    createOrGetVisitor({ amalgamVisitorId })
      .then(() => {
        this.setState({ visitorInitialized: true });
      })
      .catch(() => {
        // handled unresolved promise
      });
  };

  setAdTileVisibility = (isVisible) => {
    if (isVisible !== this.state.showAdTile) {
      setMoreCataloguesAvailable(!isVisible);
      this.setState({ showAdTile: isVisible });
    }
  };

  canRenderAdTile = () => {
    const { resetSearchState, showAdTile } = this.state;
    return showAdTile && resetSearchState;
  };

  onSearchTextChange = (text) => {
    this.setState({
      searchTerm: text,
      showSearchResults: true,
      resetSearchState: false
    });
  };

  resetSearchResultState = () => {
    const customPageScrollPosition = getCustomPageScrollPosition();
    // Note: don't remove this setTimeout, else page scroll won't work when there's pagination
    setTimeout(() => {
      window.scrollTo(0, customPageScrollPosition);
    }, 0);
    document.addEventListener('scroll', this.scrollPositionCacheHandler);
    this.setState({
      searchTerm: '',
      showSearchResults: false,
      searchClickedFromNavBar: false,
      resetSearchState: true
    });
  };

  onSearchClickFromHeader = () => {
    document.removeEventListener('scroll', this.scrollPositionCacheHandler);
    setCustomPageScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
    this.setState({
      searchClickedFromNavBar: true,
      resetSearchState: false,
      showSearchResults: true
    });
  };

  isDesktop = () => window.innerWidth > 768;

  getSlug = ({ randomSlug, companySlug, sectionType, catalogueSlug, encodedDomainTag }) => {
    if (sectionType === SECTION_TYPES.CATALOGUE) {
      return `/w/${companySlug}/${randomSlug}`;
    }
    if (encodedDomainTag) {
      return `/s/${companySlug}/${catalogueSlug}/${randomSlug}?domainTag=${encodedDomainTag}`;
    }
    return `/s/${companySlug}/${catalogueSlug}/${randomSlug}`;
  };

  renderViewAll = ({
    randomSlug,
    companySlug,
    sectionType,
    catalogueSlug = '',
    encodedDomainTag,
    sectionId,
    data
  }) => {
    if (this.isDesktop() && data.length <= CUSTOM_PAGE_SHOW_CONTENT_DESKTOP) {
      return;
    } else if (!this.isDesktop() && data.length <= CUSTOM_PAGE_SHOW_CONTENT_MOBILE) {
      return;
    }
    const { fetchingAmalgam, viewAllSectionId } = this.state;
    const { pageTextColor = '#000' } = getCatalogueTheme() || {};
    const slug = this.getSlug({
      companySlug,
      catalogueSlug,
      randomSlug,
      encodedDomainTag,
      sectionType
    });

    return (
      <div className="viewAllContainer">
        <a
          href={slug}
          target="_self"
          className="viewAll"
          style={
            fetchingAmalgam && sectionId === viewAllSectionId
              ? { border: 'none' }
              : { color: pageTextColor, borderColor: pageTextColor }
          }
          onClick={(event) => {
            if (sectionType === SECTION_TYPES.PRODUCT) {
              this.onViewAllProductsClick({
                event,
                randomSlug,
                companySlug,
                catalogueSlug,
                encodedDomainTag,
                sectionType,
                sectionId
              });
            } else {
              this.onViewAllCatalogueClick({
                event,
                randomSlug,
                companySlug,
                catalogueSlug,
                encodedDomainTag,
                sectionType,
                sectionId
              });
            }
          }}
        >
          <div
            style={
              fetchingAmalgam && sectionId === viewAllSectionId
                ? { opacity: 0 }
                : { color: pageTextColor }
            }
          >
            {I18n.t('BACK_TEXT_VIEW_ALL')}
          </div>
          <div
            className={'arrowRight'}
            style={
              fetchingAmalgam && sectionId === viewAllSectionId
                ? { opacity: 0 }
                : { color: pageTextColor }
            }
          >
            <CustomPageViewAllArrowRight color={pageTextColor} />
          </div>
          {fetchingAmalgam && sectionId === viewAllSectionId ? (
            <div
              className="fetching-amalgam-loader-container"
              style={fetchingAmalgam && sectionId === viewAllSectionId ? { opacity: 1 } : ''}
            >
              <div className="loader" style={{ borderLeftColor: pageTextColor }} />
            </div>
          ) : (
            <div />
          )}
        </a>
      </div>
    );
  };

  getContentArray = (contentArray) => {
    if (this.isDesktop() && contentArray.length > CUSTOM_PAGE_SHOW_CONTENT_DESKTOP) {
      return [...contentArray].slice(0, CUSTOM_PAGE_SHOW_CONTENT_DESKTOP);
    }
    if (!this.isDesktop() && contentArray.length > CUSTOM_PAGE_SHOW_CONTENT_MOBILE) {
      return [...contentArray].slice(0, CUSTOM_PAGE_SHOW_CONTENT_MOBILE);
    }
    return [...contentArray];
  };

  onViewAllProductsClick = ({
    event,
    companySlug,
    catalogueSlug,
    randomSlug,
    encodedDomainTag,
    sectionType,
    sectionId
  }) => {
    const slug = this.getSlug({
      companySlug,
      catalogueSlug,
      randomSlug,
      encodedDomainTag,
      sectionType
    });

    if (!shouldProcessClick(event)) {
      return;
    }

    event.stopPropagation();
    event.preventDefault();

    if (isNavigatingToCurrentLink(slug)) {
      return;
    }

    const { fetchingAmalgam } = this.state;
    if (fetchingAmalgam) {
      return;
    }

    if (isAmalgamFetched({ companySlug, catalogueSlug, randomSlug })) {
      route(slug);
      return;
    }

    EventBus.notify(EventBus.TYPE.CLEAR_SINGLE_PAGE_VIRTUOSO_CACHE);
    this.setState({ fetchingAmalgam: true, viewAllSectionId: sectionId });

    const lazyComponentFetched = isLazyComponentFetched(CHUNK_VIEW.SINGLE_CATALOGUE);

    Promise.all([
      getAmalgam({ companySlug, catalogueSlug, randomSlug }),
      lazyComponentFetched ? Promise.resolve() : importSingleBundle()
    ])
      .then(([, module]) => {
        if (!lazyComponentFetched) {
          setLazyComponent(CHUNK_VIEW.SINGLE_CATALOGUE, module.default);
        }
        if (this.isMounted) {
          this.setState({ fetchingAmalgam: false });
          route(slug);
        }
      })
      .catch(() => {});
  };

  onViewAllCatalogueClick = ({
    event,
    companySlug,
    catalogueSlug,
    randomSlug,
    encodedDomainTag,
    sectionType,
    sectionId
  }) => {
    const slug = this.getSlug({
      companySlug,
      catalogueSlug,
      randomSlug,
      encodedDomainTag,
      sectionType
    });

    if (!shouldProcessClick(event)) {
      return;
    }

    event.stopPropagation();
    event.preventDefault();

    if (isNavigatingToCurrentLink(slug)) {
      return;
    }

    const { fetchingAmalgam } = this.state;
    if (fetchingAmalgam) {
      return;
    }

    if (isViewAllCatalogueAmalgamFetched({ randomSlug, companySlug })) {
      route(slug);
      return;
    }
    const lazyComponentFetched = isLazyComponentFetched(CHUNK_VIEW.GROUP_CATALOGUE);
    this.setState({ fetchingAmalgam: true, viewAllSectionId: sectionId });
    Promise.all([
      getViewAllCustomPageCatalogueAmalgam({ randomSlug, companySlug }),
      lazyComponentFetched ? Promise.resolve() : importGroupBundle()
    ])
      .then(([, module]) => {
        if (!lazyComponentFetched) {
          setLazyComponent(CHUNK_VIEW.GROUP_CATALOGUE, module.default);
        }

        if (this.isMounted) {
          this.setState({ fetchingAmalgam: false });
          route(slug);
        }
      })
      .catch(() => {});
  };

  onOrderBarVisibilityChanged = (orderBarVisible) => {
    this.setState({ orderBarVisible });
  };

  getLoaderContainerStyle = () => {
    const height = this.state.fetchingSections ? 32 : 0;
    const width = '100%';
    const margin = this.state.fetchingSections ? '24px 0px' : 0;
    return { height, width, margin, transition: 'all 0.2s linear' };
  };

  getLoaderStyle = () => {
    const size = this.state.fetchingSections ? 32 : 0;
    const borderWidth = this.state.fetchingSections ? 3 : 0;
    return { height: size, width: size, borderWidth, transition: 'all 0.2s linear' };
  };

  scrollPositionCacheHandler = () => {
    setCustomPageScrollPosition(window.scrollY);
  };

  getTileHeight = ({ index, rows, sectionId }) => {
    const productIds = rows[index];
    const customPage = getCustomPage();
    return Math.max(
      ...productIds.map((productId) =>
        getTileHeight(productId, productIds, true, sectionId, customPage.id)
      )
    );
  };

  onTileHeightChange = ({ index, productId, height, sectionId }) => {
    if (typeof height !== 'number') {
      return;
    }
    const customPage = getCustomPage();
    const rows = PRODUCT_SECTION_ROWS[sectionId];
    setTileHeight(
      productId,
      index === rows.length - 1 ? height - CUSTOM_PAGE_VIEW_VERTICAL_MARGIN : height,
      true,
      sectionId,
      customPage.id
    );
    if (PRODUCT_VIRTUAL_LISTS[sectionId] && PRODUCT_VIRTUAL_LISTS[sectionId].recomputeSizes) {
      PRODUCT_VIRTUAL_LISTS[sectionId].recomputeSizes(index);
    }
  };

  handleRefMount = ({ ref, sectionId }) => {
    const { selfContainerForVirtualization } = this.props;
    if (!selfContainerForVirtualization || !ref) {
      return;
    }
    this.setState({
      productVirtualListRefs: {
        ...this.state.productVirtualListRefs,
        [sectionId]: ref
      }
    });
  };

  renderProductVirtualListRow = ({ index, style, sectionId, products }) => {
    const {
      attachInquiryDeleteListener,
      attachInventoryChangeListener,
      fromBundle,
      tabIndex,
      belowPriceRenderer,
      belowPriceComponentHeight,
      actionButtonRenderer
    } = this.props;
    const rows = PRODUCT_SECTION_ROWS[sectionId];
    return (
      <ProductRow
        index={index}
        key={index}
        style={{ ...style, overflow: 'visible' }}
        productIds={rows[index]}
        products={products}
        sectionId={sectionId}
        onTileHeightChange={(productId, height, sectionId) =>
          this.onTileHeightChange({ index, productId, height, sectionId })
        }
        attachInquiryDeleteListener={attachInquiryDeleteListener}
        attachInventoryChangeListener={attachInventoryChangeListener}
        homeLayoutType={HOME_LAYOUT_TYPE.GRID}
        viewType={VIEW_TYPES.HOME_GRID}
        fromBundle={fromBundle}
        tabIndex={tabIndex}
        belowPriceRenderer={belowPriceRenderer}
        belowPriceComponentHeight={belowPriceComponentHeight}
        actionButtonRenderer={actionButtonRenderer}
        fromCustomPage
      />
    );
  };

  renderProductSection = (section) => {
    const { singleShowcases, products, itemsPerRow, productVirtualListRefs = {} } = this.state;
    const { selfContainerForVirtualization, fromBundle } = this.props;
    const { id: sectionId, title, type: sectionType, singleShowcaseId, data } = section;
    const { pageTextColor = '#000' } = getCatalogueTheme() || {};
    const productGridTileComponent = getProductGridTileComponent();
    const productsArray = [];

    const {
      catalogueSlug = '',
      randomSlug = '',
      companySlug = '',
      encodedDomainTag = ''
    } = singleShowcases.find((singleShowcase) => singleShowcase.id === singleShowcaseId) || {};

    const customPageProductIds = this.getContentArray(data);
    for (let i = 0; i < customPageProductIds.length; i++) {
      const product = products.find((product) => product.id === customPageProductIds[i]);
      if (!product) {
        // Do NOT remove this null check, it might be needed to exit loop in the case when product is deleted from the catalogue but not from section
        break;
      }
      const customPage = getCustomPage();
      const { singleShowcases = [], sections = [] } = customPage;
      const singleShowcaseId = (sections.find((section) => section.id === sectionId) || {})
        .singleShowcaseId;
      const {
        companySlug = '',
        catalogueSlug = '',
        randomSlug = ''
      } = singleShowcases.find((singleShowcase) => singleShowcase.id === singleShowcaseId) || {};
      product.companySlug = companySlug;
      product.catalogueSlug = catalogueSlug;
      product.randomSlug = randomSlug;
      productsArray.push(product);
    }

    if (productsArray.length === 0) {
      return;
    }

    const rows = [];
    while (productsArray.length) {
      rows.push(productsArray.splice(0, itemsPerRow).map((product) => product.id));
    }
    PRODUCT_SECTION_ROWS[sectionId] = rows;

    return (
      <section className="sectionContainer productSectionContainer" key={sectionId}>
        {!!title && title.length > 0 && (
          <h2 className="sectionTitle" style={{ color: pageTextColor }}>
            {title}
          </h2>
        )}
        {!!productGridTileComponent &&
        !!productGridTileComponent.html &&
        !isResellerBundleView(fromBundle) ? (
            rows.map((row, rowIndex) => (
              <div key={rowIndex} className="custom-page-product-custom-component-list">
                {row.map((productId, productIndex) => (
                  <ProductGridTileCustomComponent
                    key={productIndex}
                    productId={productId}
                    sectionId={sectionId}
                    fromCustomPage
                    viewType={VIEW_TYPES.HOME_GRID}
                    html={productGridTileComponent.html}
                    style={productGridTileComponent.style}
                  />
                ))}
              </div>
            ))
          ) : (
            <CustomVirtualList
              ref={(element) => (PRODUCT_VIRTUAL_LISTS[sectionId] = element)}
              wrapperStyles={{ overflow: 'visible' }}
              listTopOffset={0}
              overscanHeight={window.innerHeight / 2}
              rowCount={rows.length}
              getRowHeight={(index) => this.getTileHeight({ index, rows, sectionId })}
              isAlwaysVisible={() => true}
              renderRow={({ index, style }) =>
                this.renderProductVirtualListRow({ index, style, sectionId, products: productsArray })
              }
              wrapperClassName="custom-page-product-custom-virtual-list"
              rootElement={productVirtualListRefs[sectionId]}
              willSendRootElement={selfContainerForVirtualization}
            />
          )}
        {this.renderViewAll({
          randomSlug,
          companySlug,
          sectionType,
          catalogueSlug,
          encodedDomainTag,
          sectionId,
          data
        })}
      </section>
    );
  };

  renderCatalogueSection = (section) => {
    const { catalogues, groupShowcases } = this.state;
    const {
      id: sectionId,
      title,
      type: sectionType,
      data = [],
      settings = {},
      groupShowcaseId
    } = section;
    const {
      hideCatalogueTitle = false,
      hideProductCount = false,
      hideSectionTitle = false,
      hideSectionSubTitle = false,
      sectionLayoutColumns = CUSTOM_PAGE_CATALOGUE_TILES_PER_ROW_DEFAULT,
      sectionSubTitle
    } = settings || {};
    const { pageTextColor = '#000' } = getCatalogueTheme() || {};

    const catalogueArrayIds = this.getContentArray(data);
    const customPageSectionCataloguesList = catalogueArrayIds.map((catalogueId) =>
      catalogues.find((catalogue) => catalogueId === catalogue.id)
    );
    const { randomSlug = '', companySlug = '' } =
      groupShowcases.find((groupShowcase) => groupShowcase.id === groupShowcaseId) || {};

    return (
      <section className="sectionContainer catalogueSectionContainer" key={sectionId}>
        {!hideSectionTitle && !!title && title.length > 0 && (
          <h2 className="sectionTitle" style={{ color: pageTextColor }}>
            {title}
          </h2>
        )}
        {!hideSectionSubTitle && !!sectionSubTitle && sectionSubTitle.length > 0 && (
          <h3 className="sectionSubTitle" style={{ color: pageTextColor }}>
            {sectionSubTitle}
          </h3>
        )}
        {shouldRenderCustomPageCatalogueSettingsSection() ? (
          <CustomPageCatalogueList
            setAdTileVisibility={this.setAdTileVisibility}
            customPageSectionCataloguesList={customPageSectionCataloguesList}
            sectionId={sectionId}
            groupShowcaseId={groupShowcaseId}
            totalCataloguesCount={data.length}
            fromCustomPage
            hideCatalogueTitle={hideCatalogueTitle}
            hideProductCount={hideProductCount}
            sectionLayoutColumns={sectionLayoutColumns}
          />
        ) : (
          <CatalogueList
            setAdTileVisibility={this.setAdTileVisibility}
            customPageSectionCataloguesList={customPageSectionCataloguesList}
            sectionId={sectionId}
            groupShowcaseId={groupShowcaseId}
            totalCataloguesCount={data.length}
            fromCustomPage
            hideCatalogueTitle={hideCatalogueTitle}
            hideProductCount={hideProductCount}
            sectionLayoutColumns={sectionLayoutColumns}
          />
        )}
        {this.renderViewAll({
          randomSlug,
          companySlug,
          sectionType,
          sectionId,
          data
        })}
      </section>
    );
  };

  renderTextSection = (section) => {
    const { id: sectionId, title, data } = section;
    const { pageTextColor = '#000' } = getCatalogueTheme() || {};

    return (
      <section className="sectionContainer textSectionContainer" key={sectionId}>
        {!!title && title.length > 0 && (
          <h2 className="sectionTitle" style={{ color: pageTextColor }}>
            {title}
          </h2>
        )}
        <CustomHtmlRenderer
          html={data && data[0] && data[0].text ? data[0].text : ''}
          className="customPageTextSectionContainer"
          hostStyle={`color: ${pageTextColor};`}
        />
      </section>
    );
  };

  renderHtmlSection = (section) => {
    const { sections } = this.state;
    const { id: sectionId, data, settings } = section;

    const sectionContainsSingleHtml =
      sections.length === 1 && sections[0].type === SECTION_TYPES.HTML;
    const hideCustomPageHeader = !!(
      sectionContainsSingleHtml &&
      sections[0].settings &&
      sections[0].settings.hideCustomPageHeader
    );
    const hideCustomPageFooter = !!(
      sectionContainsSingleHtml &&
      sections[0].settings &&
      sections[0].settings.hideCustomPageFooter
    );

    return (
      <section
        className="sectionContainer htmlSectionContainer"
        key={sectionId}
        style={{
          height:
            sectionContainsSingleHtml && hideCustomPageHeader && hideCustomPageFooter
              ? '100%'
              : undefined,
          width:
            sectionContainsSingleHtml && hideCustomPageHeader && hideCustomPageFooter
              ? '100%'
              : undefined
        }}
      >
        <CustomHtmlRenderer
          html={data && data[0] && data[0].html ? data[0].html : ''}
          style={data && data[0] && data[0].style ? data[0].style : ''}
          className="customPageHtmlSectionContainer"
          type={settings && settings.type ? settings.type : HTML_TYPES.SHADOW_DOM}
          containerStyle={{
            height:
              sectionContainsSingleHtml && hideCustomPageHeader && hideCustomPageFooter
                ? '100%'
                : undefined,
            width:
              sectionContainsSingleHtml && hideCustomPageHeader && hideCustomPageFooter
                ? '100%'
                : undefined,
            overflow:
              sectionContainsSingleHtml &&
              hideCustomPageHeader &&
              hideCustomPageFooter &&
              settings.type === HTML_TYPES.IFRAME
                ? 'hidden'
                : undefined
          }}
        />
      </section>
    );
  };

  renderSection = ({ section, sectionIndex }) => {
    const { id: sectionId, title, data } = section || {};

    if (!section || !data || data.length === 0) {
      return;
    }

    const customPage = getCustomPage();
    const { title: customPageTitle, isFrontPage } = customPage;

    switch (section.type) {
      case SECTION_TYPES.BANNER: {
        return (
          <CustomPageBanner
            key={sectionId}
            sliderUniqueId={`section-${sectionId}`}
            className={'sectionContainer'}
            banners={data}
            title={title}
            description={isFrontPage ? document.title : customPageTitle}
            fromCustomPage
          />
        );
      }

      case SECTION_TYPES.CATEGORIES: {
        return (
          <CustomPageCategoriesList
            key={sectionId}
            className={'sectionContainer'}
            sectionId={sectionId}
            categories={data}
            title={title}
            fromCustomPage
          />
        );
      }

      case SECTION_TYPES.TEXT: {
        return this.renderTextSection(section, sectionIndex);
      }

      case SECTION_TYPES.HTML: {
        return this.renderHtmlSection(section, sectionIndex);
      }

      case SECTION_TYPES.CATALOGUE: {
        return this.renderCatalogueSection(section, sectionIndex);
      }

      case SECTION_TYPES.PRODUCT: {
        return this.renderProductSection(section, sectionIndex);
      }

      default: {
        return null;
      }
    }
  };

  renderContent = () => {
    const { searchTerm, showSearchResults, sections } = this.state;

    const sectionContainsSingleHtml =
      sections.length === 1 && sections[0].type === SECTION_TYPES.HTML;
    const hideCustomPageHeader = !!(
      sectionContainsSingleHtml &&
      sections[0].settings &&
      sections[0].settings.hideCustomPageHeader
    );
    const hideCustomPageFooter = !!(
      sectionContainsSingleHtml &&
      sections[0].settings &&
      sections[0].settings.hideCustomPageFooter
    );

    if (showSearchResults) {
      return (
        <div className="search-section">
          <SearchResults searchTerm={searchTerm} />
        </div>
      );
    }

    if (!sections.length) {
      return (
        <div className="no-content">
          <NoSection />
        </div>
      );
    }

    return (
      <Fragment>
        <main
          className="sectionListContainer"
          style={{
            height:
              sectionContainsSingleHtml && hideCustomPageHeader && hideCustomPageFooter
                ? '100%'
                : undefined,
            width:
              sectionContainsSingleHtml && hideCustomPageHeader && hideCustomPageFooter
                ? '100%'
                : undefined,
            marginTop: sectionContainsSingleHtml ? 0 : undefined,
            paddingTop: sectionContainsSingleHtml ? 0 : undefined,
            marginBottom: sectionContainsSingleHtml ? 0 : undefined,
            paddingBottom: sectionContainsSingleHtml ? 0 : undefined
          }}
        >
          {sections.map((section, index) => this.renderSection({ section, sectionIndex: index }))}
        </main>
        <PrimaryLoader
          containerStyle={this.getLoaderContainerStyle()}
          loaderStyle={this.getLoaderStyle()}
        />
      </Fragment>
    );
  };

  render () {
    const {
      visitorInitialized,
      showSearchResults,
      searchClickedFromNavBar,
      resetSearchState,
      sections
    } = this.state;

    const sectionContainsSingleHtml =
      sections.length === 1 && sections[0].type === SECTION_TYPES.HTML;
    const hideCustomPageHeader = !!(
      sectionContainsSingleHtml &&
      sections[0].settings &&
      sections[0].settings.hideCustomPageHeader
    );
    const hideCustomPageFooter = !!(
      sectionContainsSingleHtml &&
      sections[0].settings &&
      sections[0].settings.hideCustomPageFooter
    );

    return (
      <div
        className="customLayoutPageContainer"
        style={{
          height:
            sectionContainsSingleHtml && hideCustomPageHeader && hideCustomPageFooter
              ? '100%'
              : undefined,
          width:
            sectionContainsSingleHtml && hideCustomPageHeader && hideCustomPageFooter
              ? '100%'
              : undefined
        }}
      >
        {!showSearchResults && (
          <CommonHeader
            showBanner={resetSearchState}
            showSearch
            goBack={this.props.goBack}
            onSearch={this.onSearchClickFromHeader}
            showExpandedHeader={false}
            showHeaderCollapsedBorder={false}
            showHeaderCollapsedShadow
            headerTagStyle={{
              height: hideCustomPageHeader ? 0 : undefined,
              width: hideCustomPageHeader ? 0 : undefined,
              overflow: hideCustomPageHeader ? 'hidden' : undefined,
              padding: hideCustomPageHeader ? 0 : undefined,
              margin: hideCustomPageHeader ? 0 : undefined
            }}
            containerStyle={{
              height: hideCustomPageHeader ? 0 : undefined,
              width: hideCustomPageHeader ? 0 : undefined,
              overflow: hideCustomPageHeader ? 'hidden' : undefined,
              padding: hideCustomPageHeader ? 0 : undefined,
              margin: hideCustomPageHeader ? 0 : undefined
            }}
          />
        )}
        <SearchBar
          onSearchTextChange={this.onSearchTextChange}
          resetSearchState={resetSearchState}
          searchClickedFromNavBar={searchClickedFromNavBar}
          fromCustomPage
          containerStyle={{
            height: hideCustomPageHeader ? 0 : undefined,
            width: hideCustomPageHeader ? 0 : undefined,
            overflow: hideCustomPageHeader ? 'hidden' : undefined,
            padding: hideCustomPageHeader ? 0 : undefined,
            margin: hideCustomPageHeader ? 0 : undefined
          }}
        />
        {!showSearchResults && <RenewalReminderCard style={{ margin: '20px auto' }} />}
        {this.renderContent()}
        {!showSearchResults && (
          <div
            className="footer-content"
            style={{
              height: hideCustomPageFooter ? 0 : undefined,
              width: hideCustomPageFooter ? 0 : undefined,
              marginTop: hideCustomPageFooter ? 0 : undefined,
              paddingTop: hideCustomPageFooter ? 0 : undefined,
              marginBottom: hideCustomPageFooter ? 0 : undefined,
              paddingBottom: hideCustomPageFooter ? 0 : undefined,
              overflow: hideCustomPageFooter ? 'hidden' : undefined,
              padding: hideCustomPageFooter ? 0 : undefined,
              margin: hideCustomPageFooter ? 0 : undefined
            }}
          >
            {this.canRenderAdTile() && <CompanyAdTile />}
            {visitorInitialized && (
              <OrderBar onVisibilityChanged={this.onOrderBarVisibilityChanged} />
            )}
            {getCompanyId() !== driftCompanyId && !shouldRemoveCompanyContactDetails() && (
              <ChatButton className="chat-button">
                <WhatsAppBrand size={30} />
                <span>{I18n.t('CHAT')}</span>
              </ChatButton>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default groupCatalogueHOC(trackWindowScroll(CustomPage));
